import React from "react";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./Route/MainRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";


function App() {
  return (
    <BrowserRouter>
      <MainRoutes />
    </BrowserRouter>
  );
}

export default App;

